<template>
    <footer class="section-footer">
        <button type="button" id="paymentbutton" class="btn" :disabled="showSpinner"
            @click="onClickPayAndPlaceOrder()">
            <div :class="['spinner', 'white-spinner', { 'spinner-visible': showSpinner }]">
                <span></span>
                <span></span>
                <span></span>
            </div>

            <template v-if="!showSpinner">
                {{payButtonText}}
            </template>
        </button>
    </footer>
</template>

<script src='./default-place-order-button.js'></script>
